<div
  class="field-type-list-button__container"
  [ngClass]="{
    'field-type-list-button__container--error': fieldTypeList.field.error,
    'field-type-list-button__container--disabled': fieldTypeList.field.noEditable
  }">
  <div class="field-type-list-button__cards-header">
    <div class="field-type-list-button__cards-header-text-container">
      <span
        class="field-type-list-button__cards-header-text"
        [ngClass]="{
          'field-type-list-button__cards-header-text--error': fieldTypeList.field.error,
          'field-type-list-button__cards-header-text--disabled': fieldTypeList.field.noEditable
        }">
        {{fieldTypeList.titleField}}
      </span>
      <span
        class="common-tag__mandatory-text-asterisk"
        [ngClass]="{
          'common-tag__mandatory-text-asterisk--disabled': fieldTypeList.field.noEditable
        }">
        *
      </span>
    </div>
    <button
      class="common-button__expand-toned"
      (click)="fieldTypeList.showLessInfo = !fieldTypeList.showLessInfo">
      <i
        class="common-icon__md"
        [ngClass]="fieldTypeList.showLessInfo ? 'lf-icon-angle-down' : 'lf-icon-angle-up'">
      </i>
      <span
        class="common-button__expand-label-text"
        [afTranslate]="fieldTypeList.showLessInfo ? 'common.expand' : 'common.collapse'">
      </span>
    </button>
  </div>
  <div class="field-type-list-button__cards-container">
    @for (listValue of listValues; track $index) {
      <div
        class="field-type-list-button__card"
        [ngClass]="{
          'field-type-list-button__card--collapsed': fieldTypeList.showLessInfo,
          'field-type-list-button__card--selected': listValue.selected,
          'field-type-list-button__card--disabled': fieldTypeList.field.noEditable || listValue.disabled,
        }">
        <div
          class="field-type-list-button__card-header"
          [ngClass]="{
            'field-type-list-button__card-header--disabled': fieldTypeList.field.noEditable || listValue.disabled
          }">
          <i
            [class]="listValue.icon + ' field-type-list-button__card-header-icon common-icon__md'"
            [ngClass]="{
              'field-type-list-button__card-header-icon--disabled': fieldTypeList.field.noEditable || listValue.disabled
            }">
          </i>
          <span
            class="field-type-list-button__card-header-title"
            [ngClass]="{
              'field-type-list-button__card-header-title--disabled': fieldTypeList.field.noEditable || listValue.disabled
            }">
            {{listValue.text}}
          </span>
        </div>
        @if(!fieldTypeList.showLessInfo){
          <ul class="field-type-list-button__card-list list-disc">
            @for (element of listValue.elements; track $index) {
              <li
                class="field-type-list-button__card-list-item"
                [ngClass]="{
                  'field-type-list-button__card-list-item--disabled': fieldTypeList.field.noEditable || listValue.disabled
                }">
                &bull; {{element}}
              </li>
            }
          </ul>
        }

        <button
          class="common-button__text-little-border"
          (click)="selectedButtonField(listValue)"
          [disabled]="fieldTypeList.field.noEditable || listValue.disabled">
          @if(listValue.selected){
            <i class="lf-icon-check-round common-icon__sm"></i>
          }
          <span
            afTranslate="field-type-list.select-button"
            class="common-button__text-little-title">
            _Seleccionar
          </span>
        </button>
      </div>
    }
  </div>
</div>
